import { SettingsManager } from "@viamap/viamap2-common";


export class cvrCollector {

   static async PEnhederPåBeliggenhed(beliggenhed: string) {
      return fetchCVR_ES({
         "size": 20,
         "_source": [
            "VrproduktionsEnhed.produktionsEnhedMetadata"
         ],
         "query": {
            "term": {
               "VrproduktionsEnhed.produktionsEnhedMetadata.nyesteBeliggenhedsadresse.adresseId.keyword": beliggenhed
            }
         }
      }, "produktionsenhed")
   }




}

async function fetchCVR_ES(query: any, index: string = "virksomhed"): Promise<any> {
   const url = SettingsManager.getSystemSetting("dllServicesUrl") + "/getcvrdata";
   const API_KEY = SettingsManager.getSystemSetting("dllServicesKey");

   // Elasticsearch body
   let esBody = {
      funktion: "hentQuery",
      "query": { ...query, size: 100 },
      "index": index
   };

   return fetch(url, {
      method: "POST",
      headers: {
         "x-api-key": API_KEY || "",
         "Content-Type": "application/json"
      },
      body: JSON.stringify(esBody)
   }).then((response) => {
      if (!response.ok) {
         throw new Error("Network response was not ok");
      }
      return response.json();
   });
}